import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import "./content.css";
import Support from '../../Components/Support/Support';

const PrivacyPolicy = () => {
  return (<div className="terms content_page">
   
    <div className="terms-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 pt-5">
            <div className="terms-info-wraps">
  
      {/* <Breadcrumb name={"Privacy Policy"} pageName={"Privacy Policy"} /> */}
      <div className="privacy-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="privacy-info-wraps">
                <h4>Privacy Policy</h4>
                <h4>Table of Contents:</h4>
                <p>A. General</p>
                <p>B. Applicability</p>
                <p>C. Access</p>
                <p>D. Personal Information</p>
                <p>E. Automatic Information Collection</p>
                <p>F. Information Security</p>
                <p>G. Use of Your Personal Information</p>
                <p>H. Exceptions</p>

                <h4>A. General</h4>
               <p>This Privacy Policy outlines how Classhila collects, uses, and protects personally identifiable
information (&quot;Personal Information&quot;). The terms &quot;we,&quot; &quot;our,&quot; and &quot;us&quot; refer to Classhila. We are
committed to safeguarding your privacy and ensuring the security of your data. Authorized
representatives of Classhila access information only on a need-to-know basis and with your
consent.</p>
<p>We prioritize the security of your personal information. We regularly review and enhance our
systems and data security measures. In the event of any suspected unauthorized use or disclosure
of your information, or upon receiving a complaint from you, we will promptly investigate the
matter. We may take appropriate legal action, including prosecution or civil proceedings, against
those responsible for any unauthorized access or disclosure.</p>
<p>By using this platform through Website/mobile application, you acknowledge and accept the
terms of this policy. If you disagree, you are advised to discontinue use immediately. Classhila
disclaims liability for issues arising from your continued use despite disagreement. If any
information you have provided or uploaded on the Platform violates the terms of this Policy,
Classhila can delete such information upon informing you of the same and revoke your access if
required without incurring any liability to you. We reserve the right to delete information that
violates this policy and revoke your access without liability upon informing you.</p>
<h4>B. Applicability</h4>
<p>This policy applies to all users of the Platform (both Website/mobile application). Users are
required to read and understand the Policy before submitting any Personal Information (defined
hereinafter). By submitting Personal Information, you consent to its use and processing per this
policy. If you submitted any Personal Information to Classhila before reading this Privacy

Policy, or if you disagree with how we collect, store, or use your Personal Information or if you
wish to delete or modify any information provided, you may contact us at <a href="mailto:help.classhila@gmail.com">help.classhila@gmail.com</a></p>
<p>Classhila keeping personal data of the user, and every user is also entitled to require Classhila to
delete and destroy all such information (but not that of other users). This policy applies solely to
the Platform and Classhila&#39;s services. Third-party websites may use cookies or other tracking
technologies on your device, collect data, or request personal information from you. Classhila is
not responsible for the privacy practices or data collection methods of these third-party websites.
Third-party websites are not covered, and their privacy practices are beyond our responsibility.
Users are encouraged to review third-party policies independently.</p>
<p>Classhila does not make any guarantees regarding the privacy practices, policies, or terms of use
of third-party websites. Furthermore, Classhila does not vouch for the accuracy, integrity, or
quality of the information, data, text, software, images, videos, messages, or other materials
provided on such websites. The inclusion or exclusion of any third-party website does not signify
endorsement by Classhila of the site, its provider, or its content. Users are strongly encouraged to
review the privacy policies of each third-party website they interact with, as any interactions or
transactions are solely the responsibility of the user and the respective third party. Classhila has
implemented reasonable precautions in compliance with applicable Indian laws and industry
standards to maintain the confidentiality of Personal Information and safeguard it from
unauthorized access, misuse, disclosure, alteration, unlawful destruction, or accidental loss.
Classhila adheres to applicable Indian laws and implements industry standards to protect your
data from unauthorized access or misuse.</p>
<h4>C. Access</h4>
<p>Users can access the Platform, register for courses, and use services as guests without creating an
account or providing Personal Information; however, Classhila does not validate or take
responsibility for the information provided by guests unless required by law, regulation, or an
order of a competent authority. To access all features and benefits on our platform, users must
create an account by providing Personal Information during the time of registration. Additional
information requested during registration on the registration page, such as receiving promotional
offers from Classhila, is optional, and Classhila may in future introduce other optional requests
for information from the User in the future to help Classhila to customize the platform to deliver
personalized user experience. Classhila will not share, rent, or sell Personal Information to third
parties without user consent, except as outlined in this Policy, and may retain records of calls for
inquiries, registered courses, feedback, or other purposes to deliver services effectively.</p>
<h4>D. Personal Information</h4>
<p>&quot;Personal Information&quot; refers to any information that identifies the User, such as name,
identification number, email address, age, gender, or phone number, provided to Classhila during
registration or at any point thereafter. It may also include &quot;sensitive personal information or data&quot;
as defined under the Information Technology (Reasonable Security Practices and Procedures and
Sensitive Personal Data or Information) Rules, 2011, such as passwords or financial account
details shared by you during registration. We request that you only provide Personal Information
when explicitly requested by us; otherwise, we assume no responsibility or liability for any such
information provided.</p>
<h4>E. Automatic Information Collection</h4>
<p>Our systems may automatically collect information when you interact with our platform, such as
IP addresses, used to connect your computer to the internet; login; email; password; computer
and connection information such as browser type and version, operating system, and platform;
course enrolled history, which we sometimes aggregate with similar information from other
users to create features, reports such as popular courses, most used features etc, the full Uniform
Resource Locator (URL) click stream to, and from our Platform, including date and time; cookie
number; courses or videos You viewed or searched for; the email id You used to call our
customer service. This data helps us how you use our platform, analyze trends, enhance user
experience, create reports on popular features and provide you with relevant content.</p>
<p>We may also use cookies and other technologies to collect information about your browsing
sessions, such as page load times and how long you spend on certain pages.&quot; During visits, we
may use software tools like JavaScript to measure and track session information, including page
interactions and response times, download errors, length of visits to certain page, course and
videos, page interaction information (such as scrolling, clicks and mouse overs), and methods
used to browse away from the page.</p>
<h4>F. Information Security</h4>
<p>To protect the security of your personal information during transmission, we use strong security
measures, including Secure Sockets Layer (SSL) encryption, to safeguard your personal
information and input. To prevent unauthorized access to sensitive information, it&#39;s essential to
protect your password, be mindful of the devices you use to access your account, and always log
out when using shared computers, laptops or any other device through which your account can
be accessed. While we prioritize security, remember that no internet transmission is entirely risk-
free.</p>
<p>However, it should be noted that given the nature of internet transactions, Classhila does not take
any responsibility for the transmission of information including Personal Information shared by
you other than as set forth in this policy. Users are responsible for safeguarding their login

credentials and devices. Any transmission of information on the internet is done at your risk and
shall not be responsible for the circumvention of the privacy settings or security measures either
by you or any third-party. Classhila is not liable for unauthorized access resulting from your
actions.</p>
<h4>G. Use of Your Personal Information</h4>
<p>You provide your personal information to Classhila when you use our services. If this
information is incorrect, you can request us to modify or delete it. We will take all reasonable
steps to ensure your personal information is accurate and used only to provide you with services
and comply with the law. When editing or deleting Personal Information, we may ask you to
verify your identity before processing such requests. Classhila may reject requests that are
illegal, require unreasonable technical effort, or involve residual copies or archives made by third
parties without our knowledge and consent. We will never retain your information longer than
necessary to provide our services or as required by Indian law. In some cases, data may be
shared with third-party service providers for operational purposes, such as payment processing/
financial data to authorize transactions under strict compliance with applicable laws. You
consent to these transfers, which Classhila will conduct all such transfers strictly in accordance
with the law.</p>
<p>Classhila shall use your personal information to deliver services on the platform effectively,
secure and improve it, fulfill our obligations to you, and communicate with you. This
communication can be through calls, texts, or emails for transactional, service-related messages,
or promotional purposes. If at any time you wish to not receive any communication from our end
you can opt out of any promotional communication by contacting us at <a href="mailto:help.classhila@gmail.com">support@classhila.com.</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
  );
};

export default PrivacyPolicy; 
